import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import HeaderRow from './HeaderRow';
import PanelDetails from './PanelDetails';
import { toCamelCase } from '@defi/core-utils';

var styles = function styles(theme) {
  return {
    wrapper: {
      height: 'calc(100% - 65px)',
      maxWidth: '100%',
      overflowX: 'hidden'
    },
    summary: {
      height: '48px !important',
      minHeight: '48px !important',
      fontWeight: 'bold'
    },
    background: {
      margin: 0,
      backgroundColor: '#fff',
      border: '1px solid #eee'
    },
    details: {
      borderTop: '1px solid #dedede',
      borderBottom: '1px solid #ccc'
    }
  };
};

export var buildTestClass = function buildTestClass(_ref) {
  var id = _ref.id,
      title = _ref.title;
  return "defiExpansion-".concat(id, "-panel-").concat(toCamelCase(title));
};

var DefiExpansion = function DefiExpansion(props) {
  var renderPanels = function renderPanels() {
    return props.children.get('rows').map(function (row, i) {
      return React.createElement(ExpansionPanel, {
        className: props.classes.background,
        expanded: props.expandedPanels[row.get('id')],
        onClick: function onClick() {
          return null;
        },
        key: i,
        "data-testid": buildTestClass({
          id: row.get('id'),
          title: row.get('title')
        })
      }, React.createElement(ExpansionPanelSummary, {
        expandIcon: React.createElement("div", null),
        className: props.classes.summary,
        "data-testid": buildTestClass({
          id: row.get('id'),
          title: 'Summary'
        })
      }, row.get('title')));
    });
  };

  return React.createElement("div", {
    className: props.classes.wrapper
  }, React.createElement(HeaderRow, {
    columns: props.children.get('headers')
  }), renderPanels());
};

export default withStyles(styles)(DefiExpansion);